// @ts-strict-ignore
import isEmpty from 'lodash/isEmpty';

import {User} from 'app_api/me/types';

import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

class UserDetailsClient extends BaseClient<User> {
  buildEndpoint({projectId, email = null}) {
    return email ? appApiUrl(`users/${email}`, {projectId}) : appApiUrl(`me/`);
  }

  buildQueryParams({projectId, includeWorkspaceUsers = false}) {
    return {
      // eslint-disable-next-line
      include_workspace_users: includeWorkspaceUsers,
      // eslint-disable-next-line
      project_id: projectId,
    };
  }

  query(params: {[key: string]: any}, queryOpts = {}) {
    return super.query(params, {...queryOpts, importance: params.email ? `auto` : `low`});
  }

  buildRequestBody(params) {
    const bodyKeys = [`user_bio`];
    const bodyParams = {};
    bodyKeys.forEach((key) => {
      if (key in params) {
        bodyParams[key] = params[key];
      }
    });

    return isEmpty(bodyParams) ? null : JSON.stringify(bodyParams);
  }

  processResponse(response) {
    return response.results;
  }
}

export const userDetailsClient = new UserDetailsClient();
